"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const reactstrap_1 = require("reactstrap");
const Spinner_1 = require("./../Spinner");
class UserMenu extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.toggleAccountMenu = () => {
            this.setState({ open: !this.state.open });
        };
    }
    render() {
        const { children, userImage } = this.props;
        const { open } = this.state;
        return (React.createElement(reactstrap_1.Dropdown, { className: "main-nav-avatar", isOpen: open, "aria-labelledby": "account-menu", toggle: this.toggleAccountMenu },
            React.createElement("a", { href: "javascript:void(0)", title: "Open account menu", id: "account-menu", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false", onClick: this.toggleAccountMenu }, userImage),
            React.createElement(Spinner_1.Spinner, { className: "main-nav-spinner" }),
            React.createElement(reactstrap_1.DropdownMenu, { right: true }, children)));
    }
}
exports.UserMenu = UserMenu;



//////////////////
// WEBPACK FOOTER
// ./src/components/UserMenu/UserMenu.tsx
// module id = 386
// module chunks = 0